import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  th: createLanguage({
    "Explore site": "แผนที่เว็บไซต์",
    "Download apps": "ดาวน์โหลด apps",
    "Explore careers": "สำรวจอาชีพ",
    "Explore salaries": "สำรวจเงินเดือน",
    "{brand} sites": "เว็บไซต์ {brand}",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "ผู้ประกอบการ",
    "Job seekers": "ผู้หางาน",
    "Register for free": "ลงทะเบียนฟรี",
    "Post a job ad": "ลงประกาศงาน",
    "Products & prices": "ผลิตภัณฑ์และราคา",
    "Customer service": "บริการลูกค้า",
    "Hiring advice": "คำแนะนำเกี่ยวกับการจ้างงาน",
    "Market insights": "ข้อมูลเชิงลึกของตลาด",
    "Recruitment software partners": "พันธมิตรซอฟต์แวร์ด้านการสรรหาบุคลากร",
    "About us": "เกี่ยวกับเรา",
    "About {brand}": "เกี่ยวกับ {brand}",
    Newsroom: "ห้องข่าว",
    Investors: "นักลงทุนสัมพันธ์",
    Careers: "ร่วมงานกับเรา",
    "International partners": "พันธมิตรต่างชาติ",
    "Partner services": "บริการสำหรับพันธมิตร",
    Contact: "ติดต่อเรา",
    "Help centre": "ศูนย์ความช่วยเหลือ",
    "Contact us": "ติดต่อเรา",
    "Product & tech blog": "บล็อกผลิตภัณฑ์และเทคโนโลยี",
    "{brand} videos": "วิดีโอ {brand}",
    Social: "โซเชียล",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "คำชี้แจงสิทธิส่วนบุคคล",
    "Terms & conditions": "ข้อกำหนดและเงื่อนไข",
    Security: "ความปลอดภัย",
    Privacy: "ความเป็นส่วนตัว",
    Community: "Community"
  }),
  id: createLanguage({
    "Explore site": "Telusuri situs",
    "Download apps": "Unduh aplikasi",
    "Explore careers": "Jelajahi karier",
    "Explore salaries": "Jelajahi gaji",
    "{brand} sites": "Situs {brand}",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Perusahaan",
    "Job seekers": "Pencari kerja",
    "Register for free": "Daftar gratis",
    "Post a job ad": "Pasang iklan lowongan kerja",
    "Products & prices": "Produk & harga",
    "Customer service": "Layanan pelanggan",
    "Hiring advice": "Saran perekrutan",
    "Market insights": "Wawasan pasar",
    "Recruitment software partners": "Mitra perangkat lunak perekrutan",
    "About us": "Tentang kami",
    "About {brand}": "Tentang {brand}",
    Newsroom: "Ruang berita",
    Investors: "Investor",
    Careers: "Karir",
    "International partners": "Mitra internasional",
    "Partner services": "Layanan mitra",
    Contact: "Kontak",
    "Help centre": "Pusat bantuan",
    "Contact us": "Hubungi kami",
    "Product & tech blog": "Blog produk & teknologi",
    "{brand} videos": "Video {brand}",
    Social: "Media sosial",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Pernyataan privasi",
    "Terms & conditions": "Persyaratan & ketentuan",
    Security: "Keamanan",
    Privacy: "Privasi",
    Community: "Komunitas"
  }),
  zh: createLanguage({
    "Explore site": "探索網站",
    "Download apps": "下載應用程式",
    "Explore careers": "就業情報",
    "Explore salaries": "薪酬趨勢",
    "{brand} sites": "{brand} 網站",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "僱主",
    "Job seekers": "求職者",
    "Register for free": "免費註冊",
    "Post a job ad": "發布招聘廣告",
    "Products & prices": "產品及價目",
    "Customer service": "客戶服務",
    "Hiring advice": "招聘建議",
    "Market insights": "市場洞察",
    "Recruitment software partners": "招聘軟件合作夥伴",
    "About us": "關於我們",
    "About {brand}": "關於 {brand}",
    Newsroom: "新聞中心",
    Investors: "投資者",
    Careers: "工作機會",
    "International partners": "國際合作夥伴",
    "Partner services": "其他合作夥伴",
    Contact: "保持聯繫",
    "Help centre": "協助中心",
    "Contact us": "聯絡我們",
    "Product & tech blog": "產品與技術網誌",
    "{brand} videos": "{brand} 影片",
    Social: "社交媒體",
    Facebook: "Facebook",
    Twitter: "X",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "私隱政策",
    "Terms & conditions": "條款及細則",
    Security: "安全",
    Privacy: "隐私",
    Community: "Community"
  }),
  "en-AU": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-HK": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download our app",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-ID": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-MY": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-NZ": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-PH": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-SG": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download apps",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "en-TH": createLanguage({
    "Explore site": "Explore site",
    "Download apps": "Download our app",
    "Explore careers": "Explore careers",
    "Explore salaries": "Explore salaries",
    "{brand} sites": "{brand} sites",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Employers",
    "Job seekers": "Job seekers",
    "Register for free": "Register for free",
    "Post a job ad": "Post a job ad",
    "Products & prices": "Products & prices",
    "Customer service": "Customer service",
    "Hiring advice": "Hiring advice",
    "Market insights": "Market insights",
    "Recruitment software partners": "Recruitment software partners",
    "About us": "About us",
    "About {brand}": "About {brand}",
    Newsroom: "Newsroom",
    Investors: "Investors",
    Careers: "Careers",
    "International partners": "International partners",
    "Partner services": "Partner services",
    Contact: "Contact",
    "Help centre": "Help centre",
    "Contact us": "Contact us",
    "Product & tech blog": "Product & tech blog",
    "{brand} videos": "{brand} videos",
    Social: "Social",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Privacy policy",
    "Terms & conditions": "Terms & conditions",
    Security: "Security",
    Privacy: "Privacy",
    Community: "Community"
  }),
  "th-TH": createLanguage({
    "Explore site": "แผนที่เว็บไซต์",
    "Download apps": "ดาวน์โหลด apps",
    "Explore careers": "สำรวจอาชีพ",
    "Explore salaries": "สำรวจเงินเดือน",
    "{brand} sites": "เว็บไซต์ {brand}",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "ผู้ประกอบการ",
    "Job seekers": "ผู้หางาน",
    "Register for free": "ลงทะเบียนฟรี",
    "Post a job ad": "ลงประกาศงาน",
    "Products & prices": "ผลิตภัณฑ์และราคา",
    "Customer service": "บริการลูกค้า",
    "Hiring advice": "คำแนะนำเกี่ยวกับการจ้างงาน",
    "Market insights": "ข้อมูลเชิงลึกของตลาด",
    "Recruitment software partners": "พันธมิตรซอฟต์แวร์ด้านการสรรหาบุคลากร",
    "About us": "เกี่ยวกับเรา",
    "About {brand}": "เกี่ยวกับ {brand}",
    Newsroom: "ห้องข่าว",
    Investors: "นักลงทุนสัมพันธ์",
    Careers: "ร่วมงานกับเรา",
    "International partners": "พันธมิตรต่างชาติ",
    "Partner services": "บริการสำหรับพันธมิตร",
    Contact: "ติดต่อเรา",
    "Help centre": "ศูนย์ความช่วยเหลือ",
    "Contact us": "ติดต่อเรา",
    "Product & tech blog": "บล็อกผลิตภัณฑ์และเทคโนโลยี",
    "{brand} videos": "วิดีโอ {brand}",
    Social: "โซเชียล",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "คำชี้แจงสิทธิส่วนบุคคล",
    "Terms & conditions": "ข้อกำหนดและเงื่อนไข",
    Security: "ความปลอดภัย",
    Privacy: "ความเป็นส่วนตัว",
    Community: "Community"
  }),
  "id-ID": createLanguage({
    "Explore site": "Telusuri situs",
    "Download apps": "Unduh aplikasi",
    "Explore careers": "Jelajahi karier",
    "Explore salaries": "Jelajahi gaji",
    "{brand} sites": "Situs {brand}",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "Perusahaan",
    "Job seekers": "Pencari kerja",
    "Register for free": "Daftar gratis",
    "Post a job ad": "Pasang iklan lowongan kerja",
    "Products & prices": "Produk & harga",
    "Customer service": "Layanan pelanggan",
    "Hiring advice": "Saran perekrutan",
    "Market insights": "Wawasan pasar",
    "Recruitment software partners": "Mitra perangkat lunak perekrutan",
    "About us": "Tentang kami",
    "About {brand}": "Tentang {brand}",
    Newsroom: "Ruang berita",
    Investors: "Investor",
    Careers: "Karir",
    "International partners": "Mitra internasional",
    "Partner services": "Layanan mitra",
    Contact: "Kontak",
    "Help centre": "Pusat bantuan",
    "Contact us": "Hubungi kami",
    "Product & tech blog": "Blog produk & teknologi",
    "{brand} videos": "Video {brand}",
    Social: "Media sosial",
    Facebook: "Facebook",
    Twitter: "Twitter",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "Pernyataan privasi",
    "Terms & conditions": "Persyaratan & ketentuan",
    Security: "Keamanan",
    Privacy: "Privasi",
    Community: "Komunitas"
  }),
  "zh-HK": createLanguage({
    "Explore site": "探索網站",
    "Download apps": "下載應用程式",
    "Explore careers": "就業情報",
    "Explore salaries": "薪酬趨勢",
    "{brand} sites": "{brand} 網站",
    "{brand} {country}": "{brand} {country}",
    Android: "Android",
    iOS: "iOS",
    "{brand} @ App Store": "{brand} @ App Store",
    "{brand} @ Google Play": "{brand} @ Google Play",
    Employers: "僱主",
    "Job seekers": "求職者",
    "Register for free": "免費註冊",
    "Post a job ad": "發布招聘廣告",
    "Products & prices": "產品及價目",
    "Customer service": "客戶服務",
    "Hiring advice": "招聘建議",
    "Market insights": "市場洞察",
    "Recruitment software partners": "招聘軟件合作夥伴",
    "About us": "關於我們",
    "About {brand}": "關於 {brand}",
    Newsroom: "新聞中心",
    Investors: "投資者",
    Careers: "工作機會",
    "International partners": "國際合作夥伴",
    "Partner services": "其他合作夥伴",
    Contact: "保持聯繫",
    "Help centre": "協助中心",
    "Contact us": "聯絡我們",
    "Product & tech blog": "產品與技術網誌",
    "{brand} videos": "{brand} 影片",
    Social: "社交媒體",
    Facebook: "Facebook",
    Twitter: "X",
    Instagram: "Instagram",
    YouTube: "YouTube",
    "Privacy policy": "私隱政策",
    "Terms & conditions": "條款及細則",
    Security: "安全",
    Privacy: "隐私",
    Community: "Community"
  }),
  "en-PSEUDO": createLanguage({
    "Explore site": "[Ëꭕƥƚöööřẽẽẽ šìììṯẽẽẽ]",
    "Download apps": "[Ḋöööŵกี้ƚöööăăăƌ ăăăƥƥš]",
    "Explore careers": "[Ëꭕƥƚöööřẽẽẽ çăăăřẽẽẽẽẽẽřš]",
    "Explore salaries": "[Ëꭕƥƚöööřẽẽẽ šăăăƚăăăřìììẽẽẽš]",
    "{brand} sites": "[{brand} šìììṯẽẽẽš]",
    "{brand} {country}": "[{brand} {country}]",
    Android: "[Ậกี้ƌřöööìììƌ]",
    iOS: "[ìììÖŠ]",
    "{brand} @ App Store": "[{brand} @ Ậƥƥ Šṯööööřẽẽẽẽ]",
    "{brand} @ Google Play": "[{brand} @ Ǧööööööģƚẽẽẽ Ƥƚăăăýýý]",
    Employers: "[Ëm̂ƥƚöööýýýẽẽẽřš]",
    "Job seekers": "[Ĵöööß šẽẽẽẽẽẽķẽẽẽřš]",
    "Register for free": "[Řẽẽẽģìììšṯẽẽẽř ƒöööř ƒřẽẽẽẽẽẽ]",
    "Post a job ad": "[Ƥöööšṯ ăăă ĵöööß ăăăƌ]",
    "Products & prices": "[Ƥřöööƌǚǚǚçṯš & ƥřìììçẽẽẽš]",
    "Customer service": "[Çǚǚǚšṯöööm̂ẽẽẽř šẽẽẽřṽìììçẽẽẽ]",
    "Hiring advice": "[Ḩìììřìììกี้ģ ăăăƌṽìììçẽẽẽ]",
    "Market insights": "[Ṃăăăřķẽẽẽṯ ìììกี้šìììģḩṯš]",
    "Recruitment software partners": "[Řẽẽẽçřǚǚǚìììṯm̂ẽẽẽกี้ṯ šöööƒṯŵăăăřẽẽẽ ƥăăăřṯกี้ẽẽẽřš]",
    "About us": "[Ậßöööǚǚǚṯ ǚǚǚš]",
    "About {brand}": "[Ậßöööǚǚǚṯ {brand}]",
    Newsroom: "[Ñẽẽẽŵšřööööööm̂]",
    Investors: "[Ïกี้ṽẽẽẽšṯöööřš]",
    Careers: "[Çăăřẽẽẽẽřš]",
    "International partners": "[Ïกี้ṯẽẽẽřกี้ăăăṯìììöööกี้ăăăƚ ƥăăăřṯกี้ẽẽẽřš]",
    "Partner services": "[Ƥăăăřṯกี้ẽẽẽř šẽẽẽřṽìììçẽẽẽš]",
    Contact: "[Çöööกี้ṯăăăçṯ]",
    "Help centre": "[Ḩẽẽẽƚƥ çẽẽẽกี้ṯřẽẽẽ]",
    "Contact us": "[Çöööกี้ṯăăăçṯ ǚǚǚš]",
    "Product & tech blog": "[Ƥřöööƌǚǚǚçṯ & ṯẽẽẽçḩ ßƚöööģ]",
    "{brand} videos": "[{brand} ṽììƌẽẽööš]",
    Social: "[Šööçììăăƚ]",
    Facebook: "[Ƒăăçẽẽßööööķ]",
    Twitter: "[Ṯŵìììṯṯẽẽẽř]",
    Instagram: "[Ïกี้šṯăăăģřăăăm̂]",
    YouTube: "[ÝööǚǚṮǚǚßẽẽ]",
    "Privacy policy": "[Ƥřììṽăăçýý ƥööƚììçýý]",
    "Terms & conditions": "[Ṯẽẽẽřm̂š & çöööกี้ƌìììṯìììöööกี้š]",
    Security: "[Šẽẽçǚǚřììṯýý]",
    Privacy: "[Ƥřììṽăăçýý]",
    Community: "[Çööm̂m̂ǚǚกี้ììṯýý]"
  })
});
export {
  translations
};
